import { getters } from '@/modules/core/app/helpers/store';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { AppModule } from '@/modules/core/app/constants/app.constants';

export class AudienceRouteConfig extends PageRouteConfig {
  /**
   * @override
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    const userSettings = getters.session.getUserSettings();
    return (
      ((userSettings.isModuleAvailable(AppModule.IO_TOOL) &&
        userSettings.user.enable_io_tool_module) ||
        (userSettings.isModuleAvailable(AppModule.STELLAR) &&
          userSettings.user.enable_stellar_module)) &&
      super.canAccessRouteFromContext()
    );
  }
}
